import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MemberSavedProviderState } from './print.state';
import { selectActiveMember } from '@store/active-member/active-member.selectors';

export const selectPrintState =
  createFeatureSelector<MemberSavedProviderState>('print');

export const selectPrintData = createSelector(
  selectPrintState,
  (state: MemberSavedProviderState) => state
);

export const selectPrintDataForActiveMember = createSelector(
  selectPrintState,
  selectActiveMember,
  (state: MemberSavedProviderState, activeMember) =>
    activeMember.id ? state[activeMember.id]?.savedProviders || [] : []
);

export const selectPrintDataForAllMembers = createSelector(
  selectPrintState,
  (state: MemberSavedProviderState) => Object.values(state || {})
);

export const selectPrintDataById = (id: string) =>
  createSelector(
    selectPrintState,
    selectActiveMember,
    (state: MemberSavedProviderState, activeMember) => {
      if (activeMember.id) {
        return (
          state[activeMember.id]?.savedProviders?.find(
            (provider) => provider.id === id
          ) || null
        );
      } else {
        return null;
      }
    }
  );
